/*
 * @Description:
 * @Author: zhanghang
 * @Date: 2022-07-27 11:31:25
 * @LastEditors: shenah
 * @LastEditTime: 2025-03-04 11:05:52
 */
import {
  utilsHandleScope,
  utilsHandleParseCode,
} from "_dataview/output/utils/event";
export default {
  mixins: [$mixins.control],
  props: {
    //是否脱离二开页面独立运行
    enableDependentRun: {
      type: Boolean,
      default: false,
    },
    //是否是大屏组件
    isDataViewControl: {
      type: Boolean,
      default: true,
    },
    //伪代码方法对象-字符串
    executeFnScope: {
      type: String,
      default: "",
    },
    //伪代码中文组件映射对象
    executeFnComp: {
      type: Object,
      default() {
        return {};
      },
    },
    //伪代码对应组件名字
    fakeCodeName: {
      type: String,
      default() {
        return "";
      },
    },
    fontSize: {
      type: [String, Number],
      default: 16,
    },
    fontWeight: {
      type: [String, Number],
      default: 500,
    },
    excelData: {
      type: Array,
      default: () => [],
    },
    padding: {
      type: Array,
      default: () => [0, 0, 0, 0],
    },
    margin: {
      type: Array,
      default: () => [0, 0, 0, 0],
    },
    height: {
      type: String,
      default: "100%",
    },
    width: {
      type: String,
      default: "100%",
    },
  },
  watch: {
    height: {
      handler(v) {
        if (this.isDesign) {
          let height = v;
          if (!v) {
            height = "auto";
          }
          if (dsf.isNumber(height) || /^\d+$/g.test(height)) {
            height += "px";
          }
          this.$dispatch("design-height-change", height);
        }
        this.$nextTick(() => {
          this.resize && this.resize();
        });
      },
      immediate: true,
    },
    width: {
      handler(v) {
        if (this.isDesign) {
          let width = v;
          if (!v) {
            width = "auto";
          }
          if (dsf.isNumber(width) || /^\d+$/g.test(width)) {
            width += "px";
          }
          this.$dispatch("design-width-change", width);
        }
        this.$nextTick(() => {
          this.resize && this.resize();
        });
      },
      immediate: true,
    },
    margin: {
      handler(v) {
        if (this.isDesign) {
          let margin = v;
          let marginTop = 0;
          let marginBottom = 0;
          if (Array.isArray(margin)) {
            marginTop = dsf.dataview.utils.transformPx(margin[0]);
            marginBottom = dsf.dataview.utils.transformPx(margin[2]);
          } else {
            marginTop = dsf.dataview.utils.transformPx(margin);
            marginBottom = dsf.dataview.utils.transformPx(margin);
          }

          this.$dispatch(
            "design-margin-change",
            `${marginTop} 0 ${marginBottom} 0`
          );
        }
      },
      immediate: true,
    },
  },
  computed: {
    dvComp() {
      return this;
    },
    fontStyle() {
      return {
        fontSize: this.transFontSize,
      };
    },
    transFontSize() {
      return dsf.dataview.utils.transformPx(this.fontSize);
    },
    controlHeight() {
      let { height, width } = this;
      width = dsf.dataview.utils.transformPx(width);
      if (!this.isDesign) {
        return {
          height: dsf.dataview.utils.transformPx(height),
          width,
        };
      }
      return {
        width,
      };
    },
    marginAndPadding() {
      let { padding: paddingArray, margin: marginArray } = this;
      const padding = dsf.dataview.utils.transformArrayPx(paddingArray);

      let margin = dsf.dataview.utils.transformArrayPx(marginArray);
      return {
        padding,
        margin,
      };
    },
    // 新增的通用背景图片为变量
    controlOuterStyle() {
      let controlStyle = this.controlStyle;
      let overStyle = dsf.dataview.utils.filterBackGroundAttr(
        controlStyle,
        false
      );
      let background = {};
      if (this.controlBackgroundConfig) {
        background = this.dvBackgroundFormat(this.controlBackgroundConfig, {
          isBgInfoVar: true,
        });
      }
      return {
        ...overStyle,
        ...background,
      };
    },
    controlStyle() {
      let {
        height,
        width,
        marginAndPadding,
        margin: marginArray,
        fontWeight,
        controlBackgroundConfig,
      } = this;
      let { margin, padding } = marginAndPadding;
      if (dsf.isNumber(height) || /^\d+$/g.test(height)) {
        height += "px";
      }
      if (dsf.isNumber(width) || /^\d+$/g.test(width)) {
        width += "px";
      }
      let background = {};
      if (controlBackgroundConfig) {
        background = this.dvBackgroundFormat(controlBackgroundConfig);
      }
      if (this.isDesign) {
        marginArray = [0, marginArray[1], 0, marginArray[3]];
        return {
          margin: dsf.dataview.utils.transformArrayPx(marginArray),
          padding,
          width,
          fontWeight: fontWeight,
          boxSizing: "border-box",
          ...background,
        };
      }

      return {
        width,
        ...marginAndPadding,
        height,
        fontWeight,
        boxSizing: "border-box",
        ...background,
      };
    },
  },
  data() {
    return {
      // 伪代码事件相关作用域
      eventScope: {},
      //当前组件值
      currentComponentData: {},
      //字数超长策略
      showFeildRules: [
        {
          overflow: "hidden",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
        },
        {
          overflow: "hidden",
          display: "-webkit-box",
          textOverflow: "ellipsis",
          "-webkit-box-orient": "vertical",
          "-webkit-line-clamp": 2,
        },
      ],
    };
  },
  created() {
    if (this.isDesign) {
      if (!this.fakeCodeName) {
        let it = this;
        //组件名字
        let ctrlName = it.ctrlName;
        let ctrlType = it.ctrlType.split(".")[1];
        //组件ref的后缀
        let sign = it.caption.substr(ctrlType.length);
        let dataviews = window.$components.dataview;
        let chineseName = dataviews[ctrlName].ctrlCaption;
        let name = `${chineseName}${sign}`;
        this.$emit("update:fakeCodeName", name);
      }
    }
  },
  methods: {
    handlePositionArrPx(arr) {
      if (Array.isArray(arr)) {
        let top = "auto";
        let right = "auto";
        let bottom = "auto";
        let left = "auto";
        if (arr.length == 2) {
          left = dsf.dataview.utils.transformPx(arr[0]);
          top = dsf.dataview.utils.transformPx(arr[1]);
        } else {
          top = dsf.dataview.utils.transformPx(arr[0]);
          right = dsf.dataview.utils.transformPx(arr[1]);
          bottom = dsf.dataview.utils.transformPx(arr[2]);
          left = dsf.dataview.utils.transformPx(arr[3]);
        }

        return {
          top,
          right,
          bottom,
          left,
        };
      }
      return {};
    },
    //大屏开启静态资源微服务前缀
    dvGetWebPath(url) {
      let page = this.$page || this;
      let $servicePrefix = void 0;
      if (page.uploadSign && !this.isDesign) {
        $servicePrefix = this.$servicePrefix || $$webRoot.default;
      }
      return dsf.url.getWebPath(url, $servicePrefix);
    },
    // 获取页面值单位转化列表
    addUnits(data) {
      let obj = dsf.dataview.units;
      let list = Object.keys(obj).map((key) => ({
        text: obj[key],
        value: key,
      }));
      list.unshift({
        text: "无",
        value: "",
      });
      data.dictionary = list;
    },
    //获取页面字体列表
    addFonts(data) {
      data.dictionary = dsf.dataview.fonts;
    },
    //获取select下拉框主题
    addSelectThemes(data) {
      data.dictionary = dsf.dataview.selectThemes;
    },

    // 兼容src统一使用bgSettingExtend的格式
    compatiblePathToObj(obj, active = "custom") {
      return dsf.dataview.utils.compatiblePathToExtendImg(obj, active);
    },
    // 兼容src并且进行反显
    handleImgSrcStr(obj) {
      return dsf.dataview.utils.compatiblePathToExtendShowImg(
        obj,
        this.dvGetWebPath
      );
    },
    //单位换算
    transformUnit() {
      return dsf.dataview.utils.transformUnit(...arguments);
    },
    getBorderCss(width, isSolid, color) {
      let border = `${dsf.dataview.utils.transformPx(width)} ${
        isSolid ? "solid" : "dashed"
      } ${color}`;
      return border;
    },
    judgeMargin(arr) {
      if (!Array.isArray(arr)) {
        return false;
      }
      if (arr.length) {
        return arr.every((item) => item !== undefined && item !== null);
      }
      return false;
    },
    // 针对设置(bgLayoutArraySetting)属性提取,返回有的属性
    abstractBgArrAttr(obj) {
      // 单个背景
      let bgObj = obj?.bgImgObj || {};
      let background = this.dvColorFormatCoexist(bgObj) || {};
      // 单个属性
      let borderRadius = obj?.borderRadius || "";
      let bgMargin = obj?.margin || "";
      let bgPadding = obj?.padding || "";
      let bgWH = obj?.wH || [];
      let bgRelative = obj?.relative;

      let bgRelativeObj = this.handlePositionArrPx(bgRelative);
      let bgRelativeStyle = {
        top: bgRelativeObj.top,
        left: bgRelativeObj.left, // 因为这里只取了前面两个所以用right的来变成left
        position: "relative",
      };
      let style = {
        ...background,
        ...bgRelativeStyle,
      };
      if (this.judgeMargin(borderRadius)) {
        style.borderRadius = dsf.dataview.utils.transformArrayPx(borderRadius);
      }
      // console.log(' style.borderRadius', style.borderRadius)
      if (this.judgeMargin(bgMargin)) {
        style.margin = dsf.dataview.utils.transformArrayPx(bgMargin);
      }
      if (this.judgeMargin(bgPadding)) {
        style.padding = dsf.dataview.utils.transformArrayPx(bgPadding);
      }
      if (bgWH.length) {
        if (bgWH[0]) {
          style.width = dsf.dataview.utils.transformPx(bgWH[0]);
        }
        if (bgWH[1]) {
          style.height = dsf.dataview.utils.transformPx(bgWH[1]);
        }
      }
      return style;
    },
    getColor(color) {
      if (color === "theme") {
        color = "@main";
      }
      return dsf.themeConfig.getThemeColor(color) || color;
    },
    // 获取当前选择风格配置项
    handlerCurrentStyleConfig(theme) {
      if (theme) {
        let style = theme.style;
        let styleMapKey = this.styleMapKey;
        this.beforeChangeStyle && this.beforeChangeStyle();
        if (style[styleMapKey]) {
          this.styleConfigCallback(style[styleMapKey], theme);
        }
      }
    },
    styleConfigCallback(options, theme) {
      const keys = Object.keys(this.$props);
      Object.keys(options).forEach((keyName) => {
        if (keys.includes(keyName)) {
          if (/backgroundConfig$/gi.test(keyName)) {
            let background = options[keyName];
            if (
              ["custom", "pattern"].includes(background.active) &&
              background[background.active]
            ) {
              let image = background[background.active].image;
              image = this.$designer.getUploadImageById(image);
              background[background.active].image = this.dvGetWebPath(image);
            }
            this.$emit(`update:${keyName}`, _.cloneDeep(background));
          } else {
            let nowVal = _.cloneDeep(options[keyName]);
            let oldVal = _.cloneDeep(this[keyName]);
            if (typeof options[keyName] === "function") {
              nowVal = options[keyName].call(this, theme);
            }
            if (_.isObject(nowVal)) {
              this.$emit(
                `update:${keyName}`,
                dsf.mix(true, Array.isArray(nowVal) ? [] : {}, oldVal, nowVal)
              );
            } else {
              this.$emit(`update:${keyName}`, nowVal);
            }
            // let nowVal = options[keyName];
            // this.$emit(`update:${keyName}`, _.cloneDeep(nowVal));
          }
        }
      });
      this.$nextTick(() => {
        this.afterChangeStyle && this.afterChangeStyle();
      });
    },
    // 相关事件作用域处理
    handleEventScope() {
      //脱离二开独立运行组件
      if (this.enableDependentRun) return false;

      if (this.executeFnScope && !this.isDesign) {
        this.eventScope = utilsHandleScope(this, this.executeFnScope);
      }
    },
    // 组件伪代码统一入口
    handleCommonEmit(code, data) {
      //脱离二开独立运行组件
      if (this.enableDependentRun) return false;

      if (!this.isDesign && code) {
        try {
          let page = this.$page.$vm;
          //给作用域注入 vm page data
          this.eventScope.vm = this;
          this.eventScope.page = page;
          this.eventScope.data = data;
          let query = this.$route.query;
          //在viewpart中打开页面-gis运行一张图
          if (page.$frame) {
            let localParams = page.$frame.localParams;
            query = { ...query, ...localParams };
          }
          this.eventScope["全局参数"] = page.$dataview;
          this.eventScope["路径参数"] = query;

          let callback = utilsHandleParseCode(code);

          callback.call(this, this.eventScope);
        } catch (error) {
          console.warn("伪代码执行失败", error);
        }
      }
    },

    //请求
    handleHTTP(url, method = "get", params = null, config = null) {
      return this.$http[method](this.$replace(url, this.local), params, config);
    },
    //显示
    handleShow() {
      this.$el.style.display = "block";
      if (typeof this.resize == "function") {
        this.$nextTick(this.resize);
      }
    },
    //隐藏
    handleHidden() {
      this.$el.style.display = "none";
      return this;
    },
    //获取组件当前值
    handleGetValue() {
      return this.currentComponentData;
    },
    //回去组件原始值
    handleGetOriginValue() {
      return this.originComponentData;
    },
    //公共页面事件
    handleTurnPage(url, isNew) {
      if (!url) return false;
      let target = url;
      //内部
      let isOut = false;
      if (dsf.isString(url)) {
        if (url.startsWith("http")) {
          isOut = true;
        } else {
          url = url.replace(/^[\/]?#/g, "");
          if (!url.startsWith("/")) {
            url = "/" + url;
          }
        }
        target = {
          path: url,
        };
      }
      if (isNew) {
        if (isOut) {
          dsf.layer.openWindow(target.path);
        } else {
          dsf.layer.openWindow(`/page.html#${target.path}`);
        }
      } else {
        if (isOut) {
          window.location.href = target.path;
        } else {
          this.$router.push(target);
        }
      }

      return this;
    },
    //打开大屏弹框
    handleOpenDataViewDialog(
      url,
      width = "50%",
      height = "500px",
      title = "",
      type,
      dialogArgs = {},
      className,
      userParams = {},
    ) {
      let dialogConfig = this.$page
        ? this.$page.dialogConfig
        : this.dialogConfig;
      width = dsf.dataview.utils.transformPx(width, false);
      height = dsf.dataview.utils.transformPx(height, false);
      if (!dialogConfig) return false;
      let style = dialogConfig.find((it) => it.id === type);
      if (!style) {
        style = dialogConfig[0];
      }
      let options = {
        title,
        params: {
          path: "",
        },
        width,
        height,
        className,
        modal: style.modal,
        dialogArgs,
        userParams,
      };
      if (dsf.isString(url)) {
        if (!url.startsWith("/")) {
          url = "/" + url;
        }
        url = url.replace(/^\/#\/pc/g, "");
        options.params.path = url;
      } else if (dsf.isObject(url)) {
        options = url;
      }
      import(
        /* webpackChunkName: "dataview_layer" */ "_dataview/output/utils/layer.js"
      ).then((res) => {
        let openDialog = res.default.openDialog.bind(this);
        openDialog(options, style);
      });
    },
    //打开弹框
    handleOpenDialog(url, width = "900px", height = "60vh", title = "") {
      if (dsf.isString(url)) {
        if (!url.startsWith("/")) {
          url = "/" + url;
        }
      }
      url = url.replace(/^\/#\/pc/g, "");
      this.$openDialog({
        title,
        width,
        height,
        params: {
          path: url,
        },
        btns: [],
      });
      return this;
    },
    commonBorderManageCompatible(obj) {
      let isShowBorder = this.$attrs[obj.isShowField];
      let borderWidth = this.$attrs[obj.borderWidthField];
      let isBorderSolid = this.$attrs[obj.isBorderSolidField];
      let borderColor = this.$attrs[obj.borderColorField];
      if (typeof isShowBorder === "boolean") {
        let borderStyle = isBorderSolid ? "solid" : "dashed";
        let style = {
          commonBorderWidth: borderWidth,
          commonBorderColor: borderColor,
          commonBorderStyle: borderStyle,
        };
        if (isShowBorder) {
          style[
            [obj.updateCssField]
          ] = `${borderWidth}px ${borderStyle} ${borderColor}`;
          this.$emit(`update:${obj.updateField}`, style);
        } else {
          this.$emit(`update:${obj.updateField}`, style);
        }
      }
    },
    //新版 适用于颜色和图片分开选择
    dvBackgroundFormat(config, attrObj = {}) {
      return dsf.dataview.utils.$backgroundFormat(
        config,
        this.dvGetWebPath,
        attrObj
      );
    },
    dvColorFormatCoexist(config) {
      return dsf.dataview.utils.$colorFormatCoexist(config, this.dvGetWebPath);
    },
  },
};
